import { evolve } from 'remeda';

import {
    type NewSlideshow,
    type NewSlideshowSlide,
    type NewUnitySlideshow,
    type NewUnitySlideshowSlide,
    type Slideshow,
    type SlideshowSlide,
    type UnitySlideshow,
    type UnitySlideshowSlide,
} from '@@api/services/slideshow/schemas';
import createImage from '@@form/components/ImageEditor/createImage';
import deserializeState from '@@plate/serialization/unity/utils/deserializeState';
import serializeState from '@@plate/serialization/unity/utils/serializeState';

import {
    deserializeImage,
    deserializeVariants,
    serializeImage,
    serializeVariants,
} from '../../utils/transformers';

export const deserializeSlideshow = (entity: UnitySlideshow): Slideshow => {
    const variants = deserializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: deserializeState(variant.lead),
        allowAutomaticTeaserUpdate: true,
    }));
    return { ...entity, variants };
};

export const serializeSlideshow = (entity: Slideshow): UnitySlideshow => {
    const variants = serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead),
    }));

    return { ...entity, variants };
};

export const serializeNewSlideshow = (entity: NewSlideshow): NewUnitySlideshow => {
    const variants = serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead),
    }));

    return {
        ...entity,
        variants,
    };
};

export const deserializeSlideshowSlide = (entity: UnitySlideshowSlide): SlideshowSlide => {
    const deserializedVariants = deserializeVariants(entity.variants, (variant) =>
        deserializeImage(
            evolve(variant, {
                image: {
                    caption: deserializeState,
                },
            }),
        ),
    );

    return {
        ...entity,
        variants: deserializedVariants.map((variant) => ({
            ...variant,
            image: createImage(variant.image),
            allowAutomaticTeaserUpdate: false,
        })),
    };
};

export const serializeSlideshowSlide = (
    entity: SlideshowSlide | NewSlideshowSlide,
): UnitySlideshowSlide | NewUnitySlideshowSlide => {
    const serializedVariants = serializeVariants(entity.variants, (variant) => {
        const serializedImage = serializeImage(variant);

        return evolve(serializedImage, {
            image: {
                caption: serializeState,
            },
        });
    });

    return {
        ...entity,
        variants: serializedVariants,
    };
};
